import {
  SET_PRESIGNED_URL,
  CLEAR_UPLOAD_DATA,
  SET_PARSING_OPTIONS
} from '@/system/store/mutation-types'

import { MutationTree, Mutation } from 'vuex'

import {
  IUploadStore, IParsingOptions
} from '@/features/upload/store'

interface IPreSignedData {
  url: string,
  fields: any
}

interface IJob {
  customerId: string,
  jobId: string,
  status: string,
  authorId: string,
  meta: any
}

interface IInitData extends IPreSignedData {
  job: IJob
}

const setPreSignedUrl: Mutation<IUploadStore> = (
  state: IUploadStore,
  { fields, url }: IPreSignedData
) => {
  state.fields = [...fields]
  state.url = url
  return state
}

const setParsingOptions: Mutation<IUploadStore> = (
  state: IUploadStore,
  parsingOptions: IParsingOptions
) => {
  state.parsingOptions = parsingOptions

  return state
}

const clearUploadData: Mutation<IUploadStore> = (
  state: IUploadStore
) => {
  state.fields = []
  state.url = ''
  return state
}

const mutations: MutationTree<IUploadStore> = {
  [SET_PRESIGNED_URL]: setPreSignedUrl,
  [SET_PARSING_OPTIONS]: setParsingOptions,
  [CLEAR_UPLOAD_DATA]: clearUploadData
}

export default mutations
